import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { SharedComponents } from "../../../components/shared.module";
import { BaseLayoutComponent } from "../../base-layout.component";
import { SidePanelViewComponent } from "./side-panel-view/side-panel-view.component";
import { TestCaesPanelViewComponent } from "./test-caes-panel-view/test-caes-panel-view.component";

@Component({
  selector: "app-llm-driven-framework",
  standalone: true,
  imports: [SidePanelViewComponent, TestCaesPanelViewComponent, CommonModule, ...SharedComponents],
  templateUrl: "./llm-driven-framework.component.html",
  styleUrl: "./llm-driven-framework.component.scss",
})
export class LlmDrivenFrameworkComponent extends BaseLayoutComponent {
  cards = [];
  isLoading: boolean = false;

  ngOnInit() {
    console.log(this.dataStore?.data?.id);
    this.loadAllVersions();
  }

  loadAllVersions() {
    this.isLoading = true;
     this.restService.getLLMGeneratedTestScripts(this.dataStore?.data?.id).subscribe(item => {
      this.cards = item?.data;
          this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
    })
  }

  trackItem(index: number, item: any) {
    return item;
  }

  handleCardAction(event: any) {
    console.log(event);
    this.restService.getLLMGeneratedTestScriptsByVersions(this.dataStore?.data?.id, event?.params?.id).subscribe(item => {
      console.log(item);
      this.restService.getExecutionSignedUrl(item?.data?.frameworkUrl).subscribe(response => {
          window.open(response?.data?.signedUrl, "_blank");
      })
    })
  }
}
